import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Award, FileText } from 'lucide-react';
export function Insurance() {
  const cards = [{
    title: 'Insurance Claim Help',
    copy: 'Get help with the quote, claim details and scheduling process.',
    icon: <FileText className="w-6 h-6 text-brand-blue" data-id="element-110" />
  }, {
    title: 'OEM & OEE Glass Options',
    copy: 'Ask about available glass options based on your vehicle, insurance, preference and budget.',
    icon: <Award className="w-6 h-6 text-brand-blue" data-id="element-111" />
  }, {
    title: 'Lifetime Workmanship Warranty',
    copy: 'Professional installation backed by a warranty on vehicle glass workmanship.',
    icon: <Shield className="w-6 h-6 text-brand-blue" data-id="element-112" />
  }];
  return <section className="py-16 lg:py-24 bg-navy-900 text-white" data-id="element-113">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-114">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-115">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-116">
            Insurance Help, Quality Glass & Warranty Protection
          </h2>
          <p className="text-lg text-slate-300" data-id="element-117">
            Kosin's Glass provides free auto glass quotes and can help
            coordinate with most insurance companies. The team installs quality
            glass that meets or exceeds OEM standards and backs auto glass
            workmanship with a lifetime vehicle glass workmanship warranty.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-118">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-navy-800 rounded-2xl p-8 border border-navy-700" data-id="element-119">
              <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-6 border border-navy-700 shadow-inner" data-id="element-120">
                {card.icon}
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-121">{card.title}</h3>
              <p className="text-slate-300 leading-relaxed" data-id="element-122">{card.copy}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}